import React, { useRef, useEffect } from 'react';

const ProjectLocationIcons = ({ id, defaultSrc, hoverSrc, titleText, iconStyle }) => {
  const iconRef = useRef(null);

  useEffect(() => {
    const handleMouseOver = () => {
      iconRef.current.setAttribute('data', hoverSrc);
    };

    const handleMouseOut = () => {
      iconRef.current.setAttribute('data', defaultSrc);
    };

    const iconElement = iconRef.current;
    if (iconElement) {
      iconElement.addEventListener('mouseover', handleMouseOver);
      iconElement.addEventListener('mouseout', handleMouseOut);
    }

    // Cleanup function to remove event listeners
    return () => {
      if (iconElement) {
        iconElement.removeEventListener('mouseover', handleMouseOver);
        iconElement.removeEventListener('mouseout', handleMouseOut);
      }
    };
  }, [hoverSrc, defaultSrc]);

  return (
    <h3 className="mkd-iwt-title" style={{ color: '#464646', marginTop: 4 }}>
      <object
        ref={iconRef}
        id={id}
        data={defaultSrc}
        type="image/svg+xml"
        style={iconStyle}
      />
      <object
        data={hoverSrc}
        type="image/svg+xml"
        style={{ display: 'none' }}
      />
      <span className="mkd-iwt-title-text">{titleText}</span>
    </h3>
  );
};

export default ProjectLocationIcons;